import { observable, makeObservable } from 'mobx';
import { useStores } from '../useStores';
import withActions from '../withActions';
import actions from './actions';

export default class UIStatesStore {

    version = '1.0';
    schedules = [];
    categories = [];

    withCategory = false;
    subscribersFields = {};
    fieldErrors = {};

    customValues = {};
    optinValues = {};
    touchedFields = {};
    required = {};
    isRequiredFilledIn = false;
    selectedCalendar = '';
    
    observed = {
    };
    
    constructor() {
        makeObservable(this, {
            observed: observable,
        });

        withActions(this, actions);
    }

}

export function useUIStatesStore () {
    const { store } = useStores();
    return store.uiStatesStore;
}
